import React from 'react';
import { motion } from 'framer-motion'; // For interactive effects

const featuresData = [
  {
    title: 'Eco-Friendly Solutions',
    description: 'Discover our range of sustainable practices that help protect the environment.',
    icon: '/Home_Page_Icon_5.png', // Replace with the correct path
  },
  {
    title: 'Innovative Technology',
    description: 'Leveraging cutting-edge technology to offer efficient ESG management solutions.',
    icon: '/Home_Page_Icon_6.png', // Replace with the correct path
  },
  {
    title: 'Community Engagement',
    description: 'Building strong, sustainable communities through active engagement and support.',
    icon: '/Home_Page_Icon_7.png', // Replace with the correct path
  },
];

const FeaturesSection = () => {
  return (
    <div className="relative bg-[#ffffff] py-16">
      {/* Interactive Shadow Boxes */}
      <div className="relative -mt-40 z-10">
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 px-4">
          {featuresData.map((feature, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              className="bg-white rounded-lg p-6 text-center flex flex-col items-center transform transition-all shadow-[-10px_10px_10px_rgba(0,0,0,0.3)]"
              style={{
                width: '299px',
                height: 'fit-content', // Set height to "hug" content
              }}
            >
              <img src={feature.icon} alt={feature.title} className="h-16 mb-4" />
              <h3 className="text-[28px] text-[#000000] font-Poppins font-bold mb-2">{feature.title}</h3>
              <p className="text-[16px] text-[#717171] font-Mulish font-semibold">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;
